import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import tryParseNumber from "assets/scripts/utils/tryParseNumber";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
import CaptchaForm from "assets/scripts/components/common/form/CaptchaForm/CaptchaForm";
const messages = defineMessages({
    submit: {
        id: "forms.accountNew.submit",
        defaultMessage: "Continue"
    },
    referenceNumberLabel: {
        id: "forms.accountNew.referenceNumber.label",
        defaultMessage: "Reference/File Number"
    },
    pinLabel: {
        id: "forms.accountNew.pin.label",
        defaultMessage: "Pin"
    },
    numbersOnlyHelp: {
        id: "forms.accountNew.numersOnlyhelp",
        defaultMessage: "Numbers only"
    }
});
function getErrors(value) {
    return {
        referenceNumber: tryParseNumber(value.referenceNumber) == null ? REQUIRED : null,
        pin: tryParseNumber(value.pin) == null ? REQUIRED : null
    };
}
export default class AccountNewForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleReferenceNumberChange = (referenceNumber) => this._handleValueChange({ referenceNumber });
        this._handlePinChange = (pin) => this._handleValueChange({ pin });
        this.state = {
            value: {
                referenceNumber: "",
                pin: ""
            }
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const { value } = state;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<CaptchaForm isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				{captcha => (<fieldset className="fieldset">
						<legend>
							<span className="u-isVisuallyHidden">
								<FormattedMessage id="forms.accountNew.legend" defaultMessage="Account Information"/>
							</span>
						</legend>

						<TextFormGroup name="referenceNumber" type="number" label={messages.referenceNumberLabel} help={messages.numbersOnlyHelp} value={value.referenceNumber} onChange={this._handleReferenceNumberChange} error={errors.referenceNumber} backendError={backendErrors.referenceNumber} required/>

						<TextFormGroup name="pin" type="number" label={messages.pinLabel} help={messages.numbersOnlyHelp} value={value.pin} onChange={this._handlePinChange} error={errors.pin} backendError={backendErrors.pin} required/>

						{process.env.CLIENT !== "CapOne" &&
            <div style={{ fontSize: "13px", marginTop: "5px", fontStyle: "italic" }}>
								<FormattedMessage id="login.newUser.info" defaultMessage="Please note that not all Reference/File Numbers will be accessible on DCMS ServiceLink®"/>
							</div>}

						{captcha}
					</fieldset>)}
			</CaptchaForm>);
    }
    _handleValueChange(value) {
        this.setState(prevState => ({
            value: {
                ...prevState.value,
                ...value
            }
        }));
    }
    _handleSubmit(captcha) {
        const value = {
            referenceNumber: tryParseNumber(this.state.value.referenceNumber),
            pin: tryParseNumber(this.state.value.pin)
        };
        this.props.create(value, captcha || undefined);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/AccountNewForm.tsx